import { Notificacion } from "@components/general/Alertas/Alertas";
import UserContext from "@context/User/UserContext";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import numberCommaSeparator from "@helpers/formateoPrecios/numberCommaSeparator";
import { enviarComprobanteLiquidacion } from "@helpers/httpRequests/httpRequestsMailers/httpRequestsMailers";
import {
  enviarCorreoFacturacion,
  retrievePaymentIntent,
} from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import Loader from "@helpers/loader/loader";
import ThumbUpSvg from "@helpers/resources/ThumbUpSvg";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useContext } from "react";
import { Animated } from "react-animated-css";
import { Button, Col, Container, Image, Navbar, Row } from "react-bootstrap";
import DatosFacturacion from "../facturacion/DatosFacturacion";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LiquidacionRealizadaLoggedIn = ({ history }) => {
  const { contextValue, setContextValue } = useContext(UserContext);

  const { usuarioLogeado } = contextValue;

  const { folioContrato, correo, nombreCompleto, apellidos } = usuarioLogeado;

  const [paymentIntent, setPaymentIntent] = useState({});

  const [paymentMethod, setPaymentMethod] = useState({});

  const [facturacionEnviada, setFacturacionEnviada] = useState(false);

  const [formValuesFacturacion, setFormValuesFacturacion] = useState({
    usoCfdi: "",
    claveCfdi: "",
    constanciaSituacionFiscalData: "",
  });

  const [showSpinner, setShowSpinner] = useState(false);

  const [showLoader, setShowLoader] = useState(true);

  const handleButtonClick = async () => {
    let montoCobro = "",
      tipoTarjeta = "";

    const { amount } = paymentIntent;

    const {
      card: { funding },
    } = paymentMethod;

    montoCobro = amount / 100;

    tipoTarjeta =
      funding === "credit" ? "Tarjeta de crédito" : "Tarjeta de débito";

    await enviarCorreoFacturacion({
      pdfData: formValuesFacturacion.constanciaSituacionFiscalData,
      folioContrato: contextValue.folioContrato,
      cfdi: {
        clave: formValuesFacturacion.claveCfdi,
        descripcion: formValuesFacturacion.usoCfdi,
      },
      metodoPago: tipoTarjeta,
      nombreCliente: `${nombreCompleto} ${apellidos}`,
      correoCliente: correo,
      montoCobro: numberCommaSeparator(montoCobro),
    });

    Notificacion("success", "Solicitud de facturación enviada con éxito");

    setFacturacionEnviada(true);
  };

  const handleBackToDashboard = () => {
    history.replace(dashboardRoutesPaths.dashboard);
  };

  useEffect(() => {
    const validarExistenciaPago = async () => {
      try {
        const {
          stripeSession: { payment_intent },
        } = contextValue;

        const { paymentIntent, paymentMethod } = await retrievePaymentIntent(
          payment_intent
        );

        setPaymentIntent(paymentIntent);

        setPaymentMethod(paymentMethod);

        const { id, amount } = paymentIntent;

        const {
          card: { last4 },
        } = paymentMethod;

        const comprobanteEnviado = await enviarComprobanteLiquidacion({
          titular: `${nombreCompleto} ${apellidos}`,
          paymentIntentId: id,
          folioContrato,
          montoCobro: amount / 100,
          numeroTarjeta: `Tarjeta con terminación ${last4}`,
          description: `Liquidación de Licencia Click+ - Folio ${folioContrato}`,
          correo,
        });

        localStorage.setItem("comprobanteEnviado", comprobanteEnviado);

        setShowLoader(false);
      } catch (error) {
        console.log("Error al enviar el comprobante de liquidación: ", error);
      }
    };

    if (localStorage.getItem("comprobanteEnviado") === null) {
      validarExistenciaPago();
    } else {
      setShowLoader(false);
    }
  }, []);

  return (
    <>
      {showLoader ? (
        <Loader />
      ) : (
        <Animated
          animationIn="fadeIn"
          animationInDuration={2000}
          animationOut="fadeOut"
          isVisible={true}
        >
          <Navbar variant="light" bg="dark">
            <Navbar.Brand href="#home">
              <Image
                fluid
                width="100"
                src={require("@assets/images/click.png")}
                alt="Logo Global Click"
              />
            </Navbar.Brand>
          </Navbar>

          <Container fluid className="py-30 bg-main-container">
            <Row>
              <Col>
                <Container fluid className="bg-light-dark">
                  <Row className="text-white">
                    <Col>
                      <Container fluid className="p-0 p-lg my-3">
                        <Row>
                          <Col className="text-center">
                            <ThumbUpSvg />
                          </Col>
                        </Row>

                        <Row>
                          <Col className="text-center">
                            <Container>
                              <Row>
                                <Col>
                                  <h3 className="text-success text-uppercase">
                                    ¡Gracias por tu pago!
                                  </h3>

                                  <p className="text-center">
                                    Tu Licencia Click+ ha sido pagada en su
                                    totalidad, sigue disfrutando de tus
                                    beneficios Click+ hasta que tu tiempo de
                                    vigencia finalice.
                                  </p>

                                  <p className="text-center">
                                    Recibirás un correo electrónico de{" "}
                                    <b>notificaciones@globalclickmexico.com</b>{" "}
                                    con tu comprobante de pago.
                                  </p>
                                </Col>
                              </Row>

                              {!facturacionEnviada && (
                                <>
                                  <DatosFacturacion
                                    formValues={formValuesFacturacion}
                                    setFormValues={setFormValuesFacturacion}
                                  />

                                  {formValuesFacturacion.facturacionSolicitada && (
                                    <Button
                                      variant="success"
                                      onClick={handleButtonClick}
                                      disabled={facturacionEnviada}
                                    >
                                      Solicitar facturación{" "}
                                      {showSpinner && (
                                        <FontAwesomeIcon
                                          icon={faSpinner}
                                          spin
                                        />
                                      )}
                                    </Button>
                                  )}
                                </>
                              )}

                              <Row>
                                <Col>
                                  <Button
                                    variant="primary"
                                    onClick={handleBackToDashboard}
                                  >
                                    Regresar a la plataforma
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </Animated>
      )}
    </>
  );
};

export default LiquidacionRealizadaLoggedIn;
